// signal.service.ts
import { computed, Injectable, signal } from '@angular/core';

import {
    ChatHistoryItem,
    CurrentConversation,
} from '../shared/interfaces/get-history-params.interface';

@Injectable({
    providedIn: 'root',
})
export class SignalService {
    private queryHistorySignal = signal<ChatHistoryItem | null>(null);

    private _currentConversation = signal<CurrentConversation>({
        conversationId: '',
        hasDeletedFiles: false,
        hasTemporaryFiles: false,
    });

    queryHistory = this.queryHistorySignal.asReadonly();

    /**
     *
     * @param newQueryHistory
     */
    setQueryHistory(newQueryHistory: ChatHistoryItem) {
        this.queryHistorySignal.set(newQueryHistory);
    }

    /**
     *
     */
    get currentConversation() {
        return this._currentConversation();
    }

    /**
     *
     * @param id
     */
    setCurrentConversationId(id: string) {
        this._currentConversation.set({
            conversationId: id,
            hasDeletedFiles: false,
            hasTemporaryFiles: false,
        });
    }

    /**
     *
     * @param partial
     */
    updateCurrentConversation(partial: Partial<CurrentConversation>) {
        this._currentConversation.update((state) => ({
            ...state,
            ...partial,
        }));
    }

    /**
     *
     */
    resetCurrentConversation() {
        this._currentConversation.set({
            conversationId: '',
            hasDeletedFiles: false,
            hasTemporaryFiles: false,
        });
    }

    readonly isConversationReadOnly = computed(() => {
        const state = this._currentConversation();
        return state.hasDeletedFiles || state.hasTemporaryFiles;
    });
}
